export function isIeltsApiSuccessEnvelope(body) {
  if (body == null || typeof body !== 'object' || body.response == null) return false;
  const code = body.responseCode;
  return code === undefined || code === null || Number(code) === 200;
}

export function isIeltsApiSuccessResponse(response, body) {
  return Boolean(response?.ok) && isIeltsApiSuccessEnvelope(body);
}
